export default __webpack_public_path__ + "static/media/background.c48f7725.jpeg";